import {Pipe, PipeTransform} from '@angular/core';
import {fieldTypeHasDefaultOption} from '../helpers/field-type-has-default-option';
@Pipe({name: 'fieldTypeHasDefaultOption'})
export class FieldTypeHasDefaultOptionPipe implements PipeTransform {
  transform(value: string): boolean {
    return fieldTypeHasDefaultOption(value);
  }
}
